import { render, staticRenderFns } from "./JournalTemplateForm.vue?vue&type=template&id=220709a0"
import script from "./JournalTemplateForm.vue?vue&type=script&lang=js"
export * from "./JournalTemplateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports